import React from 'react';
import { Box, Container, Typography, Link as MuiLink } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Link } from 'react-router-dom';

const FooterWrapper = styled(Box)(({ theme }) => ({
  backgroundColor: '#0a0a0a',
  borderTop: '1px solid #1f1f1f',
  padding: '40px 0',
  position: 'relative',
  zIndex: 100,
}));

const FooterContainer = styled(Container)({
  maxWidth: '1200px',
});

const FooterContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: '32px',
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
}));

const BrandSection = styled(Box)(({ theme }) => ({
  textAlign: 'center',
  [theme.breakpoints.up('md')]: {
    textAlign: 'left',
  },
}));

const BrandName = styled(Typography)({
  fontSize: '20px',
  fontWeight: 700,
  color: '#FF6B35',
  marginBottom: '8px',
});

const BrandTagline = styled(Typography)({
  fontSize: '14px',
  color: '#9CA3AF',
  marginBottom: '12px',
});

const ContactEmail = styled(MuiLink)({
  fontSize: '14px',
  color: '#D1D5DB',
  textDecoration: 'none',
  '&:hover': {
    color: '#FF6B35',
  },
});

const LinksSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  alignItems: 'center',
  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
    gap: '32px',
    alignItems: 'flex-start',
  },
}));

const LinkColumn = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  textAlign: 'center',
  [theme.breakpoints.up('sm')]: {
    textAlign: 'left',
  },
}));

const LinkTitle = styled(Typography)({
  fontSize: '14px',
  fontWeight: 600,
  color: '#ffffff',
  marginBottom: '4px',
});

const FooterLink = styled(Link)({
  fontSize: '14px',
  color: '#9CA3AF',
  textDecoration: 'none',
  transition: 'color 0.2s',
  '&:hover': {
    color: '#FF6B35',
  },
});

const Copyright = styled(Box)({
  marginTop: '32px',
  paddingTop: '24px',
  borderTop: '1px solid #1f1f1f',
  textAlign: 'center',
});

const CopyrightText = styled(Typography)({
  fontSize: '14px',
  color: '#6B7280',
});

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <FooterWrapper>
      <FooterContainer>
        <FooterContent>
          <BrandSection>
            <BrandName>WorkoutAIPlan</BrandName>
            <BrandTagline>AI-Powered Calisthenics Training</BrandTagline>
            <ContactEmail href="mailto:coach@workoutaiplan.com">
              coach@workoutaiplan.com
            </ContactEmail>
          </BrandSection>

          <LinksSection>
            <LinkColumn>
              <LinkTitle>Legal</LinkTitle>
              <FooterLink to="/privacy">Privacy Policy</FooterLink>
              <FooterLink to="/terms">Terms of Service</FooterLink>
              <FooterLink to="/refund">Refund Policy</FooterLink>
            </LinkColumn>

            <LinkColumn>
              <LinkTitle>Support</LinkTitle>
              <ContactEmail href="mailto:coach@workoutaiplan.com">
                Contact Us
              </ContactEmail>
            </LinkColumn>
          </LinksSection>
        </FooterContent>

        <Copyright>
          <CopyrightText>
            © {currentYear} WorkoutAIPlan. All rights reserved.
          </CopyrightText>
        </Copyright>
      </FooterContainer>
    </FooterWrapper>
  );
};

export default Footer;
